(function () {
  function initSetupWizard() {
    var setupButton = document.querySelector('#setup_wizard_btn');
    if (setupButton) {
      setupButton.addEventListener('click', function () {
        $('#setup_wizard_partial').removeClass('hidden');
      });
    }

    if (!document.querySelector('#admin_btn')) {
      return;
    }

    var steps = [
      { btn: '#admin_btn', info: '#admin_info' },
      { btn: '#teacher_btn', info: '#teacher_info' },
      { btn: '#class_btn', info: '#class_info' },
      { btn: '#roster_btn', info: '#roster_info' },
      { btn: '#assign_btn', info: '#assign_info' },
      { btn: '#section_btn', info: '#section_info' },
      { btn: '#done_btn', info: '#done_info' },
    ];

    steps.forEach(function (step) {
      $(step.btn).on('click', function () {
        steps.forEach(function (other) {
          $(other.btn).removeClass('active');
          $(other.info).addClass('d-none');
        });
        $(step.btn).addClass('active');
        $(step.info).removeClass('d-none');
      });
    });
  }

  $(document).on('turbolinks:load', initSetupWizard);
})();
